<template>
  <div class="animated fadeIn"> 
    <b-row>
     
        <b-col sm="12">
       <b-breadcrumb :items="breadcrumbs"/> 
        <b-card>   
         <b-col sm="12">      
          <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
            <b-row>           
                <b-col md="4">  
                  <b-form-group label="Client"  :label-cols="3" >
                      <!-- <b-form-select v-model="deliveryagentmasterid" name="deliveryagentmasterid" class="mySelectBox" v-validate="'required|'">
                          <option :value="selected">--Select Delivery Agent--</option>
                          <option :value="customer.deliveryagentmasterid" v-for="customer in data1">{{ customer.deliveryagentfirstname | capitalize }} {{ customer.deliveryagentlastname | capitalize }}-{{ customer.deliveryagentmasterid}}</option>s
                      </b-form-select> -->
                      <v-select  v-model="deliveryagentmasterid" :options="data1" placeholder="Select Delivery Agent" @input="selectdeliveryagent(deliveryagentmasterid)" >
                      </v-select>
                  </b-form-group>
                </b-col>  
                <b-col md="4">  
                  <b-form-group>
                      <v-date-picker mode='single' :available-dates='{ start: null, end: new Date() }' v-model='selectedValue'>
                      </v-date-picker>
                  </b-form-group>
                </b-col>   
                <b-col md="4">  
                  <b-button  type="submit" size="md" variant="primary" v-on:click="searchAgent">Search
                </b-button>
                </b-col> 
                
                <div style="clear:both"></div>
                <div id="displayErrorMessage" style="margin:5px; display:none;">
                    <span v-show="errors.has('form-1.deliveryagentmasterid')" class="help is-danger">{{ errors.first('form-1.deliveryagentmasterid') }}</span>
                    <span style="color:red">Record Not Found</span>
                </div>

            </b-row>  
            <b-row>
              <b-col md="4">
               <b-button   size="md" variant="primary" @click="distanceTravel()">Total Distance Travel
                </b-button>

              </b-col>
               <b-col md="8">
                <div v-if="this.distance !=0">
                  <label>
                   <strong> Total Distance Travel &nbsp; : &nbsp;</strong>
                  </label>
                
                <!-- <span style="">{{this.distance}}</span>  -->
                <label>
                  {{this.distance}} &nbsp;
                </label>
                <i class="fa fa-road" aria-hidden="true" style="font-size: 26px;padding-right: 10px; position: relative;top: 4px;color: #20a8d8"></i> 
                </div>
               </b-col>
            </b-row>  
          </form>
        </b-col>
           <b-col cols="12" md="12" class="mt-4">
          <div id="dvMap" style="width:100%;height:400px;" :busy="isBusy">
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
          </div>
          </b-col>
        </b-card>
      </b-col>
    </b-row>        
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants"
import Utils from "@/utils"
export default {
  data: function  () {
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    return {
       isBusy: false,
      breadcrumbs: [{
        text: 'Dashboard',
        // href: '/dashboard'
      },{
        text: 'Track Delivery Agent',
        active: true
      }],
      selected:'',
      distance:0,
      selectedValue: new Date(),
      name: 'deliveryagentmaster',
      deliveryagentmasterid: '',
      data1: [],
      // date: '20180225',
      customer: { isverified: true },
      markersTemp: [],
      markers: [
        {
          title: 'A',
          lat: '25.27537',
          lng: '55.30404',
          description: 'A'
        }
      ] 
    };
  },
  components: {},
  created: function() {
    (function()
{
  if( window.localStorage )
  {
    if( !localStorage.getItem('firstLoad') )
    {
      
      localStorage['firstLoad'] = true;
      window.location.reload();

    }
    else
      localStorage.removeItem('firstLoad');
  }
})();
    this.displaydata()
    this.setDate()
    this.getData()
    // this.distanceTravel()
  },
  methods: {
    validateForm: function(scope) {
      this.$validator.validateAll(scope).then(result => {
      });
    },
    selectdeliveryagent(value_vehicle) {
        if(value_vehicle==null){
          this.deliveryagentmasterid = '';
          this.displaydata();
          this.setDate();
          this.getData();
        }
         console.log("value_vehicle : ",value_vehicle);
      },

    setDate: function() {
      var d = new Date(this.selectedValue),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear()
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day;
      this.date = [year, month, day].join('-');
    },
    GetSortOrder: function(prop) {
      return function(a, b) {
        if (a[prop] > b[prop]) {
          return 1;
        } else if (a[prop] < b[prop]) {
          return -1;
        }
        return 0;
      };
    },
    displaydata: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      const deliveryagentobj = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1'
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagentobj)
        .then(result => {
          this.data1 = result.body;
          var data = [];
 
          result.body.forEach(function (srData) {
            data.push({
              key:srData.deliveryagentmasterid,
              label:srData.deliveryagentmasterid+ ' - '+srData.deliveryagentfirstname+ ' - '+srData.deliveryagentlastname
            });
          });
          this.data1 = data;
          // this.data1.sort(this.GetSortOrder('deliveryagentfirstname'))
        })
        .catch(ex => {
          console.log('error-----', ex)
        });
    },
    searchAgent: function() {

      this.setDate()
      this.getData()
    },
    getData: function() {
       this.isBusy = true;
      var requestObj = {
        deliveryagentmasterid: this.deliveryagentmasterid.key,
        trackdate: this.date
      };
      var myPromiss = [];
      myPromiss[0] = this.$http.post(
        `${CONSTANTS.API_URL}/DeliveryAgentTrackActivity`,
        requestObj
      );
      myPromiss[1] = this.$http.post(
        `${CONSTANTS.API_URL}/DeliveryAgentTrackLocation`,
        requestObj
      );


      Promise.all(myPromiss)
        .then(responseData => {
          this.isBusy = !this.isBusy
          if (responseData[0].data.returnmsg === 'successful') {
            this.markersTemp = responseData[0].data.returnvalue;
            this.markersTemp.sort(this.GetSortOrder('201802252055'))
          } else {
            checkFlag = 0
          }
          if (responseData[1].data.returnmsg === 'successful') {

            this.markers = responseData[1].data.returnvalue;
            this.markers.sort(this.GetSortOrder('201802252055'))
            var checkFlag = 1;
          } else {
            checkFlag = 0
          }
          if (checkFlag) {
            this.showMap()
          } else {
            this.showBlankMap()
          }
        })
        .catch(error => {
          this.showBlankMap()
          console.log('got error',error)
        });
    },

    // function for total distanceTravel
  distanceTravel:function(){
    // alert("in");
    
      this.setDate()
    // var userdata = localStorage.getItem('userData')
    //   var userInfo = JSON.parse(userdata)
    if(this.deliveryagentmasterid == ''){
      alert("Please Select Client");
      // this.$fire({
      //             text:"Please Select Client",
      //             type: "warning",
      //             timer: 30000
      //           }); 
    }
    else{
      const distanceobj = {
        
       
        id: this.deliveryagentmasterid.key,
        // date: "2021-05-19",
         date: this.date
      }
      // console.log("obj",distanceobj);
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getRiderTravelDist`, distanceobj)
        .then(result => {
          if (result.body.returnmsg=="Successful"){
         this.distance = result.body.returnvalue;
         // console.log("TotalDistance",this.distance);
         }
         else{
          this.distance=result.body.returnvalue;
         }
        })
        .catch(ex => {
          console.log('error-----', ex)
        });
        }
  },
    showBlankMap:function(){
      var mapOptions = {
        center: new google.maps.LatLng('25.27537','55.30404'),
        zoom: 10,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };
      var map = new google.maps.Map(
        document.getElementById("dvMap"),
        mapOptions
      )
    },
    showMap: function(flag) {

      var mapOptions = {
        center: new google.maps.LatLng(
          this.markers[0].location.x,
          this.markers[0].location.y
        ),
        zoom: 10,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };
      // console.log("DDDDDDDDDDDDDDD",mapOptions);
      var path = new google.maps.MVCArray();
      var bounds = new window.google.maps.LatLngBounds();
      var directionsService = new google.maps.DirectionsService();
      let directionsDisplay = new google.maps.DirectionsRenderer(
        {
          suppressMarkers: false
        });

      var infoWindow = new google.maps.InfoWindow()
      var map = new google.maps.Map(
        document.getElementById("dvMap"),
        mapOptions
      )
        let greenMarker = {
       url: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
       size: new window.google.maps.Size(25, 35),
       origin: new window.google.maps.Point(6, 0)
     };
     let redMarker = {
    url: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
    size: new window.google.maps.Size(25, 35),
    origin: new window.google.maps.Point(6, 0)
  };
     let routesArr = [];
     let wayptsArr=[];
     for (var i = 0; i < 2; i++) {
       wayptsArr.push({lat: this.markers[i].location.x,lng:this.markers[i].location.y});
     }
     for (var i = 0; i < this.markers.length; i++) {
       routesArr.push({lat: this.markers[i].location.x,lng:this.markers[i].location.y});
     }
     let startPoint= {lat:this.markers[0].location.x,lng:this.markers[0].location.y};
     let endPoint= {lat:this.markers[1].location.x,lng:this.markers[1].location.y};
     let waypts = [];
       wayptsArr.map(location =>{
         // let marker = new google.maps.Marker({
         //   position: new google.maps.LatLng(location.lat,
         //     location.lng),
         //   map,
         //   icon: greenMarker
         // });
         waypts.push({
           location: new window.google.maps.LatLng(location.lat,
             location.lng), stopover: true
         });
       });
       let firstShipment = waypts.shift();
       let lastShipment = waypts.pop();
       directionsService.route({
         origin:(firstShipment.location),
         destination:(lastShipment.location),
         waypoints: waypts,
         optimizeWaypoints: true,
         provideRouteAlternatives:true,
         travelMode: window.google.maps.TravelMode.DRIVING
       }, (response, status) => {
         if (status === window.google.maps.DirectionsStatus.OK) {
           for (let i = 0, len = response.routes.length; i < len; i++) {
             new window.google.maps.DirectionsRenderer({
               suppressMarkers: true,
               map,
               directions: response,
               routeIndex: i,
               polylineOptions: {
                 strokeColor: "green"
               }
             });
             directionsDisplay.setDirections(response);
             directionsDisplay.setMap(map);
           }
         } else {
           window.alert('Directions request failed due to ' + status);
         }
       });
       google.maps.event.addListenerOnce(map, 'idle', function() {
         google.maps.event.trigger(map, 'resize');
       });
    //  FAPosition=Field Agent Start and End Location
      // let FAStartPoint = new google.maps.Marker({
      //    position:new google.maps.LatLng(startPoint),
      //    map: map,
      //    icon: greenMarker
      //  });
      //  let FAEndPoint = new google.maps.Marker({
      //     position:new google.maps.LatLng(endPoint),
      //     map: map,
      //     icon: greenMarker
      //   });
      // let lineSymbol = {
      //    path: google.maps.SymbolPath.CIRCLE,
      //    scale: 3,
      //    strokeColor: '#393'
      //  };

      // var line = new google.maps.Polyline({
      //   path: routesArr,
      //   strokeOpacity: 1,
      //   strokeWeight: 0,
      //   icons: [{
      //     icon: lineSymbol,
      //     offset: '100%',
      //     repeat: '10px'
      //   }],
      //   map: map
      // });
      // bounds.extend(FAStartPoint.getPosition());
      // bounds.extend(FAEndPoint.getPosition());
      // map.panToBounds(bounds);
      // window.location.reload();
    }
  },
  
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
}
</script>


